import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'react-bootstrap';

const BadgeComponent = ({
  style,
  text
}) => (
  <h3 style={{ margin: '0' }}>
    <Label
      bsStyle={style}
      style={{ display: 'block', width: '100%', fontWeight: 400, padding: '0.5rem' }}
    >
      {text}
    </Label>
  </h3>
);

BadgeComponent.propTypes = {
  style: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default BadgeComponent;


// WEBPACK FOOTER //
// src/Components/BadgeComponent.jsx